
const TermsConditionPage = () => {
    return (
        <div id="contentpage">
            <div className="container my-4">
                <div className="content-page-card">
                    <h1 className="content-page-title">
                        <i className="bi bi-file-earmark-text me-2"></i>
                        Syarat & Ketentuan
                    </h1>
                    <p className="content-page-updated">Terakhir diperbarui: 14 Maret 2026</p>

                    <section className="content-section">
                        <h5>1. Ketentuan Umum</h5>
                        <p>Dengan menggunakan layanan FamilyTopUp, Anda menyetujui seluruh syarat dan ketentuan yang berlaku. Platform ini menyediakan layanan pengisian ulang (top up) kredit game secara elektronik. Setiap pengguna wajib membaca dan memahami ketentuan ini sebelum melakukan transaksi.</p>
                    </section>

                    <section className="content-section">
                        <h5>2. Akun Pengguna</h5>
                        <p>Pengguna bertanggung jawab penuh atas keamanan akun dan informasi login mereka. Setiap aktivitas yang terjadi melalui akun Anda menjadi tanggung jawab Anda sepenuhnya. Dilarang keras membagikan informasi akun kepada pihak lain.</p>
                    </section>

                    <section className="content-section">
                        <h5>3. Proses Transaksi</h5>
                        <p>Setiap transaksi yang telah dikonfirmasi dan dibayar tidak dapat dibatalkan atau dikembalikan (non-refundable). Pastikan data yang dimasukkan (User ID, Server ID, dll.) sudah benar sebelum melakukan pembayaran. FamilyTopUp tidak bertanggung jawab atas kesalahan input data oleh pengguna.</p>
                    </section>

                    <section className="content-section">
                        <h5>4. Harga dan Pembayaran</h5>
                        <p>Harga yang tertera sudah termasuk biaya layanan. Pembayaran dapat dilakukan melalui metode yang tersedia di platform. Harga dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya.</p>
                    </section>

                    <section className="content-section">
                        <h5>5. Layanan dan Ketersediaan</h5>
                        <p>FamilyTopUp berusaha memberikan layanan terbaik dan proses yang cepat. Namun, kami tidak menjamin bahwa layanan akan selalu tersedia tanpa gangguan. Waktu pemrosesan tergantung pada kondisi server game terkait.</p>
                    </section>

                    <section className="content-section">
                        <h5>6. Larangan</h5>
                        <ul>
                            <li>Menggunakan layanan untuk tujuan ilegal atau melanggar hukum</li>
                            <li>Melakukan penipuan atau transaksi menggunakan kartu/akun curian</li>
                            <li>Menyalahgunakan promo atau diskon yang diberikan</li>
                            <li>Mengganggu sistem keamanan platform</li>
                        </ul>
                    </section>

                    <section className="content-section">
                        <h5>7. Perubahan Ketentuan</h5>
                        <p>FamilyTopUp berhak mengubah syarat dan ketentuan ini kapan saja. Perubahan akan berlaku efektif sejak dipublikasikan di platform. Penggunaan berkelanjutan setelah perubahan dianggap sebagai persetujuan atas ketentuan baru.</p>
                    </section>

                    <section className="content-section">
                        <h5>8. Kontak</h5>
                        <p>Jika ada pertanyaan terkait syarat dan ketentuan ini, silakan hubungi kami melalui fitur Customer Service di platform atau melalui media sosial resmi FamilyTopUp.</p>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default TermsConditionPage;